
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<html>\n<head><title></title>\n</head>\n<body>\n    <p>{{recoveryKey}}</p>\n</body>\n</html>\n"
      return mustache.render(src, view, partials);
    };
  